import { render, staticRenderFns } from "./authority-list.vue?vue&type=template&id=c2f44402&scoped=true"
import script from "./authority-list.vue?vue&type=script&lang=js"
export * from "./authority-list.vue?vue&type=script&lang=js"
import style0 from "./authority-list.vue?vue&type=style&index=0&id=c2f44402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f44402",
  null
  
)

export default component.exports